import { HeadContent, Outlet, Scripts, createRootRouteWithContext } from '@tanstack/react-router'
import { MantineProvider } from '@mantine/core'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { ReactNode } from 'react'
import type { QueryClient } from '@tanstack/react-query'
import appCss from '@/styles/app.css?url'
import { NotFound } from '@/components/NotFound'
import { DefaultCatchBoundary } from '@/components/DefaultCatchBoundary'
import { AppLayout } from '@/layouts/AppLayout'
import { theme } from '@/styles/theme'

export const Route = createRootRouteWithContext<{
	queryClient: QueryClient
}>()({
	head: () => ({
		meta: [
			{
				charSet: 'utf-8',
			},
			{
				name: 'viewport',
				content: 'width=device-width, initial-scale=1',
			},
			{
				title: 'A HIV, Hepatitis C (HEP C) Testing and Treatment Clinic in Fort Lauderdale, Fort Pierce, Rivera Beach - Wellview Care',
			},
			{
				name: 'description',
				content:
					'Wellview Care is a specialized clinic for STD testing and treatment, with a primary focus on HIV, Hepatitis C (HEP C), and preventive services such as PrEP. Call Now!',
			},
			{
				name: 'keywords',
				content: 'Wellview Care, STD testing service, STD clinic, HIV testing center',
			},
		],
		links: [
			{
				rel: 'icon',
				href: '/favicon.ico',
				type: 'image/x-icon',
			},
			{
				rel: 'stylesheet',
				href: appCss,
			},
		],
	}),
	errorComponent: (props) => {
		return (
			<RootDocument>
				<DefaultCatchBoundary {...props} />
			</RootDocument>
		)
	},
	notFoundComponent: () => <NotFound />,
	component: RootComponent,
})

function RootComponent() {
	return (
		<RootDocument>
			<Outlet />
			{import.meta.env.DEV ? (
				<>
					<TanStackRouterDevtools />
					<ReactQueryDevtools buttonPosition="bottom-right" />
				</>
			) : null}
		</RootDocument>
	)
}

function RootDocument({ children }: Readonly<{ children: ReactNode }>) {
	return (
		<html lang={'en'}>
			<head>
				<HeadContent />
			</head>
			<body>
				<MantineProvider theme={theme}>
					<AppLayout children={children} />
				</MantineProvider>
				<Scripts />
			</body>
		</html>
	)
}
